import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpcomingTaxDeadlineAlert = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	viewBox: "0 0 199 130",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8039_8768)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				opacity: .35,
				d: "M10.3481 55.5205C15.731 51.1729 28.1084 43.7381 43.4465 35.6052C54.662 29.6461 67.4517 23.3028 80.2225 17.5123C89.2783 13.4037 98.3248 9.54811 106.79 6.34368C133.128 -3.7053 154.922 -3.27898 152.135 18.4821C148.04 50.4187 145.895 67.4621 151.1 94.92C155.096 116.044 139.978 126.683 120.203 126.43C88.0322 126.023 32.915 102.289 20.7063 96.1193C2.66966 86.9979 -9.83887 71.8237 10.3481 55.5205Z",
				fill: "#A0B9F8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.0189 101.535C16.7532 101.535 12.4666 97.3557 12.4666 92.2211V50.957C12.4666 45.8037 16.7532 41.6436 22.0189 41.6436H85.4189C90.6894 41.6436 94.976 45.8177 94.976 50.957V92.2211C94.976 97.3744 90.6894 101.535 85.4189 101.535H22.0189Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M87.1051 41.2686H20.3555C18.1868 41.2747 16.1089 42.14 14.5767 43.6748C13.0445 45.2096 12.1829 47.289 12.1804 49.4577V94.0433C12.1829 96.2144 13.0465 98.2959 14.5817 99.8311C16.1169 101.366 18.1984 102.23 20.3695 102.232H87.1051C89.2762 102.23 91.3577 101.366 92.8929 99.8311C94.4282 98.2959 95.2917 96.2144 95.2942 94.0433V49.4577C95.2917 47.2865 94.4282 45.205 92.8929 43.6698C91.3577 42.1346 89.2762 41.271 87.1051 41.2686ZM25.9867 100.326H20.3648C19.5376 100.329 18.718 100.169 17.9528 99.8543C17.1876 99.54 16.492 99.0778 15.9057 98.4942C15.3195 97.9106 14.8542 97.217 14.5365 96.4532C14.2188 95.6895 14.055 94.8705 14.0544 94.0433V90.3798H25.9867V100.326ZM25.9867 88.6745H14.0544V78.1055H25.9867V88.6745ZM25.9867 76.4049H14.0544V65.8312H25.9867V76.4049ZM25.9867 64.1306H14.0544V53.6974L25.9679 53.6412L25.9867 64.1306ZM39.4368 100.326H27.6872V90.3798H39.4368V100.326ZM39.4368 88.6745H27.6872V78.1055H39.4368V88.6745ZM39.4368 76.4049H27.6872V65.8312H39.4368V76.4049ZM39.4368 64.1306H27.6872V53.6319L39.4368 53.585V64.1306ZM52.887 100.326H41.1374V90.3798H52.887V100.326ZM52.887 88.6745H41.1374V78.1055H52.887V88.6745ZM52.887 76.4049H41.1374V65.8312H52.887V76.4049ZM52.887 64.1306H41.1374V53.5803L52.887 53.5428V64.1306ZM66.3372 100.326H54.5876V90.3798H66.3372V100.326ZM66.3372 88.6745H54.5876V78.1055H66.3372V88.6745ZM66.3372 76.4049H54.5876V65.8312H66.3372V76.4049ZM66.3372 64.1306H54.5876V53.5382H66.3372V64.1306ZM79.7874 100.326H68.0378V90.3798H79.7874V100.326ZM79.7874 88.6745H68.0378V78.1055H79.7874V88.6745ZM79.7874 76.4049H68.0378V65.8312H79.7874V76.4049ZM79.7874 64.1306H68.0378V53.5101H79.7874V64.1306ZM93.3734 94.0433C93.3709 95.7087 92.7083 97.3052 91.5306 98.4829C90.353 99.6605 88.7565 100.323 87.091 100.326H81.4692V90.3798H93.3687L93.3734 94.0433ZM93.3734 88.6745H81.4739V78.1055H93.3734V88.6745ZM93.3734 76.4049H81.4739V65.8312H93.3734V76.4049ZM93.3734 64.1306H81.4739V53.5194C87.2222 53.5194 91.5463 53.571 93.3734 53.6319V64.1306Z",
				fill: "#2C64EF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M73.6127 58.7852C55.665 67.5364 59.1459 78.2788 65.536 81.1084C71.3686 83.6851 81.0335 82.2141 85.8401 74.7136C90.4406 67.5364 84.3831 56.4427 68.2298 64.168",
				stroke: "#A0B9F8",
				strokeWidth: 2.56261,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.456 22.5439H123.234C119.677 22.5439 116.793 25.428 116.793 28.9856V93.0321C116.793 96.5897 119.677 99.4737 123.234 99.4737H164.456C168.014 99.4737 170.898 96.5897 170.898 93.0321V28.9856C170.898 25.428 168.014 22.5439 164.456 22.5439Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.601 28.4463H124.72C123.312 28.4463 122.171 29.5873 122.171 30.9948V41.2031C122.171 42.6106 123.312 43.7517 124.72 43.7517H162.601C164.009 43.7517 165.15 42.6106 165.15 41.2031V30.9948C165.15 29.5873 164.009 28.4463 162.601 28.4463Z",
				fill: "#2C64EF",
				stroke: "#2C64EF",
				strokeWidth: 1.40545,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M161.379 60.6826H125.942C123.86 60.6826 122.171 62.3711 122.171 64.4539V90.4314C122.171 92.5142 123.86 94.2027 125.942 94.2027H161.379C163.461 94.2027 165.15 92.5142 165.15 90.4314V64.4539C165.15 62.3711 163.461 60.6826 161.379 60.6826Z",
				fill: "#C0D0FA",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M146.467 47.8936H123.68C122.847 47.8936 122.171 48.5689 122.171 49.4021V55.3237C122.171 56.1568 122.847 56.8322 123.68 56.8322H146.467C147.3 56.8322 147.975 56.1568 147.975 55.3237V49.4021C147.975 48.5689 147.3 47.8936 146.467 47.8936Z",
				fill: "#A0B9F8",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M163.51 47.8936H152.309C151.708 47.8936 151.222 48.3802 151.222 48.9804V55.7453C151.222 56.3456 151.708 56.8322 152.309 56.8322H163.51C164.11 56.8322 164.597 56.3456 164.597 55.7453V48.9804C164.597 48.3802 164.11 47.8936 163.51 47.8936Z",
				fill: "#A0B9F8",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M132.914 60.6826V94.1324",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M143.661 60.6826V94.1324",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M154.403 60.6826V94.1324",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.879 72.001H122.406",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M154.328 82.7012H122.677",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M105.76 117.196V125.085C105.76 127.156 113.12 128.833 122.199 128.833C131.278 128.833 138.638 127.156 138.638 125.085V117.196C138.638 115.13 131.278 113.448 122.199 113.448C113.12 113.448 105.76 115.13 105.76 117.196Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.638 117.196C138.638 119.267 131.278 120.944 122.199 120.944C113.12 120.944 105.76 119.267 105.76 117.196",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.638 117.196C138.638 119.267 131.278 120.944 122.199 120.944C113.12 120.944 105.76 119.267 105.76 117.196",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M107.32 109.499V117.407C107.32 119.473 114.685 121.155 123.764 121.155C132.843 121.155 140.203 119.478 140.203 117.407V109.499C140.203 107.428 132.843 105.751 123.764 105.751C114.685 105.751 107.32 107.428 107.32 109.499Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M140.203 109.499C140.203 111.565 132.843 113.247 123.764 113.247C114.685 113.247 107.32 111.57 107.32 109.499",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M140.203 109.499C140.203 111.565 132.843 113.247 123.764 113.247C114.685 113.247 107.32 111.57 107.32 109.499",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.288 102.884V110.792C164.288 112.862 171.648 114.54 180.727 114.54C189.806 114.54 197.166 112.862 197.166 110.792V102.884C197.166 100.818 189.806 99.1357 180.727 99.1357C171.648 99.1357 164.288 100.818 164.288 102.884Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.166 102.884C197.166 104.954 189.806 106.632 180.727 106.632C171.648 106.632 164.288 104.954 164.288 102.884",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M197.166 102.884C197.166 104.954 189.806 106.632 180.727 106.632C171.648 106.632 164.288 104.954 164.288 102.884",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M101.301 101.797V109.705C101.301 111.775 108.66 113.453 117.74 113.453C126.819 113.453 134.179 111.775 134.179 109.705V101.797C134.179 99.7307 126.819 98.0488 117.74 98.0488C108.66 98.0488 101.301 99.7307 101.301 101.797Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M134.179 101.797C134.179 103.868 126.819 105.545 117.74 105.545C108.66 105.545 101.301 103.868 101.301 101.797",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M134.179 101.797C134.179 103.868 126.819 105.545 117.74 105.545C108.66 105.545 101.301 103.868 101.301 101.797",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M105.76 91.0223V98.9303C105.76 101.001 113.12 102.678 122.199 102.678C131.278 102.678 138.638 101.001 138.638 98.9303V91.0223C138.638 88.9563 131.278 87.2744 122.199 87.2744C113.12 87.2744 105.76 88.9563 105.76 91.0223Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M138.638 91.0215C138.638 93.0922 131.278 94.7694 122.199 94.7694C113.12 94.7694 105.76 93.0922 105.76 91.0215",
				stroke: "#2C64EF",
				strokeWidth: 1.95358,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M151.929 118.812L159.449 123.966C167.005 126.955 179.523 122.438 181.416 111.317C182.432 105.371 180.919 100.654 178.221 97.4634L171.161 91.5137",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M151.929 118.812L159.449 123.966C167.005 126.955 179.523 122.438 181.416 111.317C182.432 105.371 180.919 100.654 178.221 97.4634L171.161 91.5137",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.532 89.6119C172.112 89.7805 178.806 96.5173 176.885 107.775C175.012 118.878 162.475 123.394 154.918 120.424C149.015 118.082 144.485 110.815 148.055 100.654C150.707 93.0833 158.999 89.4807 164.532 89.6119Z",
				fill: "white",
				stroke: "#2C64EF",
				strokeWidth: 2,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M161.969 112.67L161.833 113.879C161.814 114.037 161.763 114.189 161.684 114.327C161.605 114.464 161.499 114.585 161.372 114.68C161.245 114.775 161.1 114.844 160.945 114.882C160.791 114.92 160.631 114.926 160.474 114.9C160.153 114.855 159.862 114.687 159.661 114.432C159.46 114.178 159.366 113.855 159.397 113.532L159.532 112.333C158.235 112.054 157.012 111.504 155.944 110.717C155.76 110.575 155.607 110.397 155.495 110.193C155.383 109.99 155.314 109.766 155.293 109.535C155.271 109.303 155.298 109.07 155.37 108.85C155.443 108.629 155.56 108.426 155.714 108.253C156.001 107.937 156.396 107.741 156.821 107.705C157.246 107.668 157.669 107.794 158.005 108.056C158.958 108.793 160.09 109.264 161.285 109.419C162.568 109.583 163.454 109.143 163.533 108.449C163.627 107.62 162.681 107.18 161.149 106.669C158.83 105.915 155.602 104.94 155.995 101.595C156.239 99.4591 158.113 97.7257 161.186 97.6507L161.336 96.3343C161.376 96.0119 161.539 95.7176 161.792 95.5132C162.044 95.3087 162.366 95.2101 162.69 95.238C162.849 95.2479 163.004 95.2898 163.146 95.3614C163.288 95.433 163.415 95.5327 163.517 95.6545C163.62 95.7762 163.696 95.9176 163.743 96.0698C163.789 96.2221 163.804 96.3822 163.786 96.5404L163.636 97.8897C164.639 98.097 165.6 98.4707 166.48 98.9953C166.696 99.1265 166.879 99.3052 167.015 99.5178C167.151 99.7304 167.237 99.9713 167.265 100.222C167.294 100.473 167.266 100.727 167.181 100.965C167.097 101.203 166.96 101.419 166.78 101.595C166.495 101.887 166.12 102.073 165.716 102.123C165.311 102.173 164.902 102.084 164.555 101.872C163.671 101.305 162.669 100.946 161.627 100.822C160.38 100.701 159.846 101.146 159.776 101.759C159.692 102.509 160.554 102.86 162.147 103.333C164.54 104.097 167.909 105.175 167.534 108.487C167.248 111.157 165.257 112.745 161.969 112.67Z",
				fill: "#2C64EF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8039_8768",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 198.145,
			height: 129.826,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgUpcomingTaxDeadlineAlert);
export { ForwardRef as ReactComponent };
